export default {
  methods: {
    mediaSize(size){
      if(!size){
        return
      }
      const i = Math.floor( Math.log(size) / Math.log(1024) )
      return `${( size / Math.pow(1024, i) ).toFixed(2) * 1} ${['b', 'Kb', 'Mb', 'Gb'][i]}`
    },
    mediaCheckLimits({ type, size }){
      let sizeLimit = 0
      if(/^video\/mp4/.test(type)){
        // Telegram: 20mb
        // Viber: 26mb
        sizeLimit = 20 * 1024 * 1024
      } else if(/^image/.test(type)){
        // Telegram: 5mb
        // Viber: iOS:1mb / Android: 3mb
        sizeLimit = 1024 * 1024
      } else if(/^audio\/(mpeg|ogg)/.test(type)){
        // Telegram: 20mb
        // Viber: (see file)
        sizeLimit = 20 * 1024 * 1024
      } else if (/^application\/(zip|pdf)/.test(type)) {
        // Telegram: 20mb / only zip, pdf, gif
        // Viber: 50mb
        sizeLimit = 20 * 1024 * 1024
      } else {
        return { isValid: false, message: `File type ${type} is not supported` }
      }

      if(size > sizeLimit){
        return { isValid: false, message: `File size ${this.mediaSize(size)} is larger than ${this.mediaSize(sizeLimit)}` }
      }

      return { isValid: true }
    },
  }
}